import Tippy from '@tippyjs/react';

const Tooltip = ({ content, children, ...props }) => {
    return typeof window !== 'undefined'
        ? (
            <Tippy content={content} {...props}>{children}</Tippy>
        ) : <span title={content}>{children}</span>
};

export default Tooltip;
